import constants from 'common/constants'

import {
  CHECK_GENERATE_VOUCHER_CHUNK,
  CLOSE_GENERATE_VOUCHER_RUN,
  CREATE_GENERATE_VOUCHER_RUN,
  GET_CURRENT_GENERATE_VOUCHER_RUN,
  GET_GENERATE_VOUCHER_OPTIONS,
  GET_GENERATE_VOUCHER_PREVIEW_STUDENTS,
  GET_GENERATE_VOUCHER_RUN,
  GET_GENERATE_VOUCHER_RUNS,
  GET_GENERATE_VOUCHER_STUDENTS,
  PREVIEW_GENERATE_VOUCHERS,
  RUN_GENERATE_VOUCHER_CHUNK,
} from './ActionTypes/ApiActionTypes'

const request = (type, path, requestType, body, onSuccess, onFailure) => ({
  type,
  payload: {
    apiUrl: constants.api_generate_vouchers,
    getString: path,
    useBaseURL: true,
    requestType,
    header: 'application/json',
    body,
    reduxActionType: '',
    onSuccess,
    onFailure,
  },
})

export const getGenerateVoucherOptions = (onSuccess, onFailure) =>
  request(GET_GENERATE_VOUCHER_OPTIONS, '/options', 'GET', undefined, onSuccess, onFailure)

export const getGenerateVoucherStudents = (data, onSuccess, onFailure) =>
  request(GET_GENERATE_VOUCHER_STUDENTS, '/students', 'POST', data, onSuccess, onFailure)

export const previewGenerateVouchers = (data, onSuccess, onFailure) =>
  request(PREVIEW_GENERATE_VOUCHERS, '/preview', 'POST', data, onSuccess, onFailure)

export const getGenerateVoucherPreviewStudents = (data, onSuccess, onFailure) =>
  request(
    GET_GENERATE_VOUCHER_PREVIEW_STUDENTS,
    '/preview/students',
    'POST',
    data,
    onSuccess,
    onFailure
  )

export const createGenerateVoucherRun = (data, onSuccess, onFailure) =>
  request(CREATE_GENERATE_VOUCHER_RUN, '/create', 'POST', data, onSuccess, onFailure)

export const getCurrentGenerateVoucherRun = (onSuccess, onFailure) =>
  request(GET_CURRENT_GENERATE_VOUCHER_RUN, '/current', 'GET', undefined, onSuccess, onFailure)

export const getGenerateVoucherRun = (id, onSuccess, onFailure) =>
  request(GET_GENERATE_VOUCHER_RUN, `/${id}`, 'GET', undefined, onSuccess, onFailure)

export const getGenerateVoucherRuns = (data, onSuccess, onFailure) =>
  request(GET_GENERATE_VOUCHER_RUNS, '', 'POST', data, onSuccess, onFailure)

export const runGenerateVoucherChunk = (id, index, onSuccess, onFailure) =>
  request(RUN_GENERATE_VOUCHER_CHUNK, `/${id}/chunks/${index}`, 'POST', {}, onSuccess, onFailure)

export const checkGenerateVoucherChunk = (id, index, onSuccess, onFailure) =>
  request(
    CHECK_GENERATE_VOUCHER_CHUNK,
    `/${id}/chunks/${index}/check`,
    'POST',
    {},
    onSuccess,
    onFailure
  )

export const closeGenerateVoucherRun = (id, onSuccess, onFailure) =>
  request(CLOSE_GENERATE_VOUCHER_RUN, `/${id}/close`, 'POST', {}, onSuccess, onFailure)
